import invert from 'lodash/invert';

export const ISSUES_ENV_TYPES = {
  LOCAL: 'Local',
  DEV: 'Development',
  QA: 'QA',
  STAGING: 'Staging',
  PROD: 'Production'
};

export const ENV_TYPE_BY_ISSUES_ENV_TYPE = invert(ISSUES_ENV_TYPES);

export const ANALYTICS_ENV_TYPES = {
  [ISSUES_ENV_TYPES.LOCAL]: 'Local',
  [ISSUES_ENV_TYPES.DEV]: 'Dev',
  [ISSUES_ENV_TYPES.QA]: 'QA',
  [ISSUES_ENV_TYPES.STAGING]: 'Staging',
  [ISSUES_ENV_TYPES.PROD]: 'Prod'
};

export const ANALYTICS_MODULE_NAME = 'PJM';

export const MIXPANEL_TOKEN = {
  DEV: '24dd3f06d727b1d4d5d68a81008ba6b6',
  PROD: 'b9f193abcc9f2cffa8c08ef96851e551'
};

export const LAUNCH_DARKLY_API_KEYS = {
  [ISSUES_ENV_TYPES.LOCAL]: '5b45eabff7e5022c88c5536f',
  [ISSUES_ENV_TYPES.DEV]: '5b45ea3f9f8c0d2c7648ae90',
  [ISSUES_ENV_TYPES.QA]: '5b45ea2b5ebaba2c7c5337fc',
  [ISSUES_ENV_TYPES.STAGING]: '5b45ea1ccdd2a52c65b8e54f',
  [ISSUES_ENV_TYPES.PROD]: '5b45e4b09f8c0d2c7648ad34'
};

export const ISSUES_REGIONS = {
  US: 'US',
  EMEA: 'EMEA',
  FEDRAMP: 'FEDRAMP'
};

const US_CONFIG = {
  [ISSUES_ENV_TYPES.LOCAL]: {
    DOCS: 'http://dm-local.autodesk.com:3000',
    APIGEE_HOST: 'https://developer-stg.api.autodesk.com',
    DM: '/dm-staging/v1/cmd-dev', //TODO - remove all DM V1 and replace them with V2 (can be found in AttachmentUploadThunk.js)
    DM_V2: '/dm-dev/v2',
    ISSUES: '/issues-dev/v1',
    ISSUES_V2: '/issues-dev/v2',
    CHECKLIST: '/checklists-dev/v1',
    CHECKLIST_FE: 'https://field.b360-qa.autodesk.com',
    DERIVATIVE_SERVICE: '/derivativeservice/v2',
    DOCS_SDK_CONFIG: {
      region: 'US',
      env: 'Local'
    },
    LBS_SDK_CONFIG: {
      env: 'Dev'
    },
    REPORT_SDK_CONFIG: {
      env: 'local',
      region: 'us'
    },
    ANALYTICS: {
      MODULE_NAME: ANALYTICS_MODULE_NAME,
      ENV: ANALYTICS_ENV_TYPES[ISSUES_ENV_TYPES.LOCAL],
      MIXPANEL: {
        TOKEN: MIXPANEL_TOKEN.DEV
      }
    },
    LAUNCH_DARKLY: {
      API_KEY: LAUNCH_DARKLY_API_KEYS[ISSUES_ENV_TYPES.LOCAL],
      USE_DEFAULTS: false
    },
    BCF_EXPORT_BASE_URL: 'https://vskzhwchcg.execute-api.eu-central-1.amazonaws.com/dev',
    ACM_NAMESPACE: 'WIPDMSecured',
    REPORT_SYNC_TIMEOUT_SECONDS: 10,
    BULK_CREATE_PERMISSION_COUNT_LIMIT: 4,
    ADMIN_V2: '/bim360-qa/admin/v1',
    CONSTRUCTION_V1: '/construction-qa/admin/v1/'
  },
  [ISSUES_ENV_TYPES.DEV]: {
    DOCS: 'https://docs.b360-dev.autodesk.com',
    APIGEE_HOST: 'https://developer-stg.api.autodesk.com',
    DM: '/dm-staging/v1/cmd-dev',
    DM_V2: '/dm-dev/v2',
    ISSUES: '/issues-dev/v1',
    ISSUES_V2: '/issues-dev/v2',
    CHECKLIST: '/checklists-dev/v1',
    CHECKLIST_FE: 'https://field.b360-dev.autodesk.com',
    DERIVATIVE_SERVICE: '/derivativeservice/v2',
    DOCS_SDK_CONFIG: {
      region: 'US',
      env: 'Qa'
    },
    LBS_SDK_CONFIG: {
      env: 'Dev'
    },
    REPORT_SDK_CONFIG: {
      env: 'qa',
      region: 'us'
    },
    ANALYTICS: {
      MODULE_NAME: ANALYTICS_MODULE_NAME,
      ENV: ANALYTICS_ENV_TYPES[ISSUES_ENV_TYPES.DEV],
      MIXPANEL: {
        TOKEN: MIXPANEL_TOKEN.DEV
      }
    },
    LAUNCH_DARKLY: {
      API_KEY: LAUNCH_DARKLY_API_KEYS[ISSUES_ENV_TYPES.DEV],
      USE_DEFAULTS: false
    },
    BCF_EXPORT_BASE_URL: 'https://vskzhwchcg.execute-api.eu-central-1.amazonaws.com/dev',
    ACM_NAMESPACE: 'WIPDMSecured',
    REPORT_SYNC_TIMEOUT_SECONDS: 10,
    BULK_CREATE_PERMISSION_COUNT_LIMIT: 4,
    ADMIN_V2: '/bim360-qa/admin/v1',
    CONSTRUCTION_V1: '/construction-qa/admin/v1/'
  },
  [ISSUES_ENV_TYPES.QA]: {
    DOCS: 'https://docs.b360-qa.autodesk.com',
    APIGEE_HOST: 'https://developer-stg.api.autodesk.com',
    DM: '/dm-staging/v1/cmd-qa',
    DM_V2: '/dm-qa/v2',
    ISSUES: '/issues-qa/v1',
    ISSUES_V2: '/issues-qa/v2',
    CHECKLIST: '/checklists-qa/v1',
    CHECKLIST_FE: 'https://field.b360-qa.autodesk.com',
    DERIVATIVE_SERVICE: '/derivativeservice/v2',
    DOCS_SDK_CONFIG: {
      region: 'US',
      env: 'Qa'
    },
    LBS_SDK_CONFIG: {
      env: 'Qa'
    },
    REPORT_SDK_CONFIG: {
      env: 'qa',
      region: 'us'
    },
    ANALYTICS: {
      MODULE_NAME: ANALYTICS_MODULE_NAME,
      ENV: ANALYTICS_ENV_TYPES[ISSUES_ENV_TYPES.QA],
      MIXPANEL: {
        TOKEN: MIXPANEL_TOKEN.DEV
      }
    },
    LAUNCH_DARKLY: {
      API_KEY: LAUNCH_DARKLY_API_KEYS[ISSUES_ENV_TYPES.QA],
      USE_DEFAULTS: false
    },
    BCF_EXPORT_BASE_URL: 'https://7c65d2nn08.execute-api.eu-central-1.amazonaws.com/qa',
    ACM_NAMESPACE: 'WIPDMSecured',
    REPORT_SYNC_TIMEOUT_SECONDS: 10,
    BULK_CREATE_PERMISSION_COUNT_LIMIT: 4,
    ADMIN_V2: '/bim360-qa/admin/v1',
    CONSTRUCTION_V1: '/construction-qa/admin/v1/'
  },
  [ISSUES_ENV_TYPES.STAGING]: {
    DOCS: 'https://docs.b360-staging.autodesk.com',
    APIGEE_HOST: 'https://developer-stg.api.autodesk.com',
    DM: '/dm-staging/v1/cmd-staging',
    DM_V2: '/dm/v2',
    ISSUES: '/issues-stg/v1',
    ISSUES_V2: '/issues-stg/v2',
    CHECKLIST: '/checklists-stg/v1',
    CHECKLIST_FE: 'https://field.b360-staging.autodesk.com',
    DERIVATIVE_SERVICE: '/derivativeservice/v2',
    DOCS_SDK_CONFIG: {
      region: 'US',
      env: 'Staging'
    },
    LBS_SDK_CONFIG: {
      env: 'Staging'
    },
    REPORT_SDK_CONFIG: {
      env: 'stg',
      region: 'us'
    },
    ANALYTICS: {
      MODULE_NAME: ANALYTICS_MODULE_NAME,
      ENV: ANALYTICS_ENV_TYPES[ISSUES_ENV_TYPES.STAGING],
      MIXPANEL: {
        TOKEN: MIXPANEL_TOKEN.DEV
      }
    },
    LAUNCH_DARKLY: {
      API_KEY: LAUNCH_DARKLY_API_KEYS[ISSUES_ENV_TYPES.STAGING],
      USE_DEFAULTS: false
    },
    BCF_EXPORT_BASE_URL: 'https://6f5vnrcqm6.execute-api.eu-central-1.amazonaws.com/stg',
    ACM_NAMESPACE: 'WIPDMSTG',
    REPORT_SYNC_TIMEOUT_SECONDS: 60,
    BULK_CREATE_PERMISSION_COUNT_LIMIT: 20,
    ADMIN_V2: '/bim360/admin/v1',
    CONSTRUCTION_V1: '/construction/admin/v1/'
  },
  [ISSUES_ENV_TYPES.PROD]: {
    DOCS: 'https://docs.b360.autodesk.com',
    APIGEE_HOST: 'https://developer.api.autodesk.com',
    DM: '/dm/v1',
    DM_V2: '/dm/v2',
    ISSUES: '/issues/v1',
    ISSUES_V2: '/issues/v2',
    CHECKLIST: '/checklists/v1',
    CHECKLIST_FE: 'https://field.b360.autodesk.com',
    DERIVATIVE_SERVICE: '/derivativeservice/v2',
    DOCS_SDK_CONFIG: {
      region: 'US',
      env: 'Production'
    },
    LBS_SDK_CONFIG: {
      env: 'Production'
    },
    REPORT_SDK_CONFIG: {
      env: 'prod',
      region: 'us'
    },
    ANALYTICS: {
      MODULE_NAME: ANALYTICS_MODULE_NAME,
      ENV: ANALYTICS_ENV_TYPES[ISSUES_ENV_TYPES.PROD],
      MIXPANEL: {
        TOKEN: MIXPANEL_TOKEN.PROD
      }
    },
    LAUNCH_DARKLY: {
      API_KEY: LAUNCH_DARKLY_API_KEYS[ISSUES_ENV_TYPES.PROD],
      USE_DEFAULTS: false
    },
    BCF_EXPORT_BASE_URL: 'https://8diqqpy9md.execute-api.eu-central-1.amazonaws.com/prod',
    ACM_NAMESPACE: 'WIPDM',
    REPORT_SYNC_TIMEOUT_SECONDS: 60,
    BULK_CREATE_PERMISSION_COUNT_LIMIT: 20,
    ADMIN_V2: '/bim360/admin/v1',
    CONSTRUCTION_V1: '/construction/admin/v1/'
  }
};

const EMEA_CONFIG = {
  // When no EMEA specific config - use US config (dev, QA etc.)
  [ISSUES_ENV_TYPES.LOCAL]: US_CONFIG[ISSUES_ENV_TYPES.LOCAL],
  [ISSUES_ENV_TYPES.DEV]: US_CONFIG[ISSUES_ENV_TYPES.DEV],
  [ISSUES_ENV_TYPES.QA]: US_CONFIG[ISSUES_ENV_TYPES.QA],
  [ISSUES_ENV_TYPES.STAGING]: {
    DOCS: 'https://docs.b360-staging.eu.autodesk.com',
    APIGEE_HOST: 'https://developer-stg.api.autodesk.com',
    DM: '/dm-staging/v1/regions/eu/cmd-staging',
    DM_V2: '/dm/v2',
    ISSUES: '/issues-stg/v1',
    ISSUES_V2: '/issues-stg/v2',
    CHECKLIST: '/checklists-stg/v1',
    CHECKLIST_FE: 'https://field.b360-staging.eu.autodesk.com',
    DERIVATIVE_SERVICE: '/derivativeservice/v2/regions/eu',
    DOCS_SDK_CONFIG: {
      region: 'EMEA',
      env: 'Staging'
    },
    LBS_SDK_CONFIG: {
      env: 'Staging'
    },
    REPORT_SDK_CONFIG: {
      env: 'stg',
      region: 'emea'
    },
    ANALYTICS: {
      MODULE_NAME: ANALYTICS_MODULE_NAME,
      ENV: ANALYTICS_ENV_TYPES[ISSUES_ENV_TYPES.STAGING],
      MIXPANEL: {
        TOKEN: MIXPANEL_TOKEN.DEV
      }
    },
    LAUNCH_DARKLY: {
      API_KEY: LAUNCH_DARKLY_API_KEYS[ISSUES_ENV_TYPES.STAGING],
      USE_DEFAULTS: false
    },
    BCF_EXPORT_BASE_URL: 'https://6f5vnrcqm6.execute-api.eu-central-1.amazonaws.com/stg',
    ACM_NAMESPACE: 'WIPDMBIMEMEASTG',
    REPORT_SYNC_TIMEOUT_SECONDS: 60,
    BULK_CREATE_PERMISSION_COUNT_LIMIT: 20,
    ADMIN_V2: '/bim360/admin/v1',
    CONSTRUCTION_V1: '/construction/admin/v1/'
  },
  [ISSUES_ENV_TYPES.PROD]: {
    DOCS: 'https://docs.b360.eu.autodesk.com',
    APIGEE_HOST: 'https://developer.api.autodesk.com',
    DM: '/dm/v1/regions/eu/cmd',
    DM_V2: '/dm/v2',
    ISSUES: '/issues/v1',
    ISSUES_V2: '/issues/v2',
    CHECKLIST: '/checklists/v1',
    CHECKLIST_FE: 'https://field.b360.eu.autodesk.com',
    DERIVATIVE_SERVICE: '/derivativeservice/v2/regions/eu',
    DOCS_SDK_CONFIG: {
      region: 'EMEA',
      env: 'Production'
    },
    LBS_SDK_CONFIG: {
      env: 'Production'
    },
    REPORT_SDK_CONFIG: {
      env: 'prod',
      region: 'emea'
    },
    ANALYTICS: {
      MODULE_NAME: ANALYTICS_MODULE_NAME,
      ENV: ANALYTICS_ENV_TYPES[ISSUES_ENV_TYPES.PROD],
      MIXPANEL: {
        TOKEN: MIXPANEL_TOKEN.PROD
      }
    },
    LAUNCH_DARKLY: {
      API_KEY: LAUNCH_DARKLY_API_KEYS[ISSUES_ENV_TYPES.PROD],
      USE_DEFAULTS: false
    },
    BCF_EXPORT_BASE_URL: 'https://8diqqpy9md.execute-api.eu-central-1.amazonaws.com/prod',
    ACM_NAMESPACE: 'WIPDMEMEAPROD',
    REPORT_SYNC_TIMEOUT_SECONDS: 60,
    BULK_CREATE_PERMISSION_COUNT_LIMIT: 20,
    ADMIN_V2: '/bim360/admin/v1',
    CONSTRUCTION_V1: '/construction/admin/v1/'
  }
};

const FEDRAMP_CONFIG = {
  // When no FEDRAMP specific config - use US config (dev, QA etc.)
  [ISSUES_ENV_TYPES.LOCAL]: US_CONFIG[ISSUES_ENV_TYPES.LOCAL],
  [ISSUES_ENV_TYPES.DEV]: US_CONFIG[ISSUES_ENV_TYPES.DEV],
  [ISSUES_ENV_TYPES.QA]: US_CONFIG[ISSUES_ENV_TYPES.QA],
  [ISSUES_ENV_TYPES.STAGING]: {
    DOCS: 'https://docs.b360-staging.afg.us.autodesk.com',
    APIGEE_HOST: 'https://api-stg.afg.us.autodesk.com',
    DM: '/dm-staging/v1/cmd-staging',
    DM_V2: '/dm/v2',
    ISSUES: '/issues-stg/v1',
    ISSUES_V2: '/issues-stg/v2',
    CHECKLIST: '/checklists-stg/v1',
    CHECKLIST_FE: 'https://field.b360-staging.autodesk.com',
    DERIVATIVE_SERVICE: '/derivativeservice/v2',
    DOCS_SDK_CONFIG: {
      region: 'FEDRAMP',
      env: 'Staging'
    },
    LBS_SDK_CONFIG: {
      env: 'Staging',
      apigeeUrl: 'https://api-stg.afg.us.autodesk.com'
    },
    REPORT_SDK_CONFIG: {
      env: 'stg',
      region: 'fedramp'
    },
    ANALYTICS: false, // MixPanel is not supported in the FedRAMP region
    LAUNCH_DARKLY: {
      API_KEY: LAUNCH_DARKLY_API_KEYS[ISSUES_ENV_TYPES.STAGING],
      USE_DEFAULTS: false
    },
    BCF_EXPORT_BASE_URL: '',
    ACM_NAMESPACE: 'WIPDMFEDRAMPSTG',
    REPORT_SYNC_TIMEOUT_SECONDS: 60,
    BULK_CREATE_PERMISSION_COUNT_LIMIT: 20,
    ADMIN_V2: '/bim360/admin/v1',
    CONSTRUCTION_V1: '/construction/admin/v1/'
  },
  [ISSUES_ENV_TYPES.PROD]: {
    DOCS: 'https://docs.b360.afg.us.autodesk.com',
    APIGEE_HOST: 'https://api.afg.us.autodesk.com',
    DM: '/dm/v1',
    DM_V2: '/dm/v2',
    ISSUES: '/issues/v1',
    ISSUES_V2: '/issues/v2',
    CHECKLIST: '/checklists/v1',
    CHECKLIST_FE: 'https://field.b360.autodesk.com',
    DERIVATIVE_SERVICE: '/derivativeservice/v2',
    DOCS_SDK_CONFIG: {
      region: 'FEDRAMP',
      env: 'Production'
    },
    LBS_SDK_CONFIG: {
      env: 'Production',
      apigeeUrl: 'https://api.afg.us.autodesk.com'
    },
    REPORT_SDK_CONFIG: {
      env: 'prod',
      region: 'fedramp'
    },
    ANALYTICS: false, // MixPanel is not supported in the FedRAMP region
    LAUNCH_DARKLY: {
      API_KEY: LAUNCH_DARKLY_API_KEYS[ISSUES_ENV_TYPES.PROD],
      USE_DEFAULTS: false
    },
    BCF_EXPORT_BASE_URL: '',
    ACM_NAMESPACE: 'WIPDMFEDRAMP',
    REPORT_SYNC_TIMEOUT_SECONDS: 60,
    BULK_CREATE_PERMISSION_COUNT_LIMIT: 20,
    ADMIN_V2: '/bim360/admin/v1',
    CONSTRUCTION_V1: '/construction/admin/v1/'
  }
};

export const ENV_CONFIGS = {};

export const initEnvConfig = ({region, env, apigeeUrl}) => {
  switch (region) {
    case ISSUES_REGIONS.US:
      Object.assign(ENV_CONFIGS, US_CONFIG[env]);
      break;
    case ISSUES_REGIONS.EMEA:
      Object.assign(ENV_CONFIGS, EMEA_CONFIG[env]);
      break;
    case ISSUES_REGIONS.FEDRAMP:
      Object.assign(ENV_CONFIGS, FEDRAMP_CONFIG[env]);
      break;
    default:
      throw new Error(
        'Unsupported region passed to Issues-UI package. Region should be one of the following: ',
        Object.values(ISSUES_REGIONS).join(', ')
      );
  }

  if (apigeeUrl) {
    ENV_CONFIGS.APIGEE_HOST = apigeeUrl;
    const sdkConfigs = ['DOCS_SDK_CONFIG', 'LBS_SDK_CONFIG'];
    sdkConfigs.forEach(sdkConfig => {
      ENV_CONFIGS[sdkConfig].apigeeUrl = apigeeUrl;
    });
  }

  ENV_CONFIGS.REGION = region;
};
